import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import animals from './views/animals.vue'
import art from './views/art.vue'
import books from './views/books.vue'
import cartoon from './views/cartoon.vue'
import celebrities from './views/celebrities.vue'
import computers from './views/computers.vue'
import film from './views/film.vue'
import geography from './views/geography.vue'
import history from './views/history.vue'
import math from './views/math.vue'
import music from './views/music.vue'
import nature from './views/nature.vue'
import politics from './views/politics.vue'
import sports from './views/sports.vue'
import vehiles from './views/vehiles.vue'
import videoG from './views/videoG.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/animals',
      name: 'animals',
      component: animals
    },
    {
      path: '/art',
      name: 'art',
      component: art
    },
    {
      path: '/books',
      name: 'books',
      component: books
    },
    {
      path: '/cartoon',
      name: 'cartoon',
      component: cartoon
    },
    {
      path: '/celebrities',
      name: 'celebrities',
      component: celebrities
    },
    {
      path: '/computers',
      name: 'computers',
      component: computers
    },
    {
      path: '/film',
      name: 'film',
      component: film
    },
    {
      path: '/geography',
      name: 'geography',
      component: geography
    },
    {
      path: '/history',
      name: 'history',
      component: history
    },
    {
      path: '/math',
      name: 'math',
      component: math
    },
    {
      path: '/music',
      name: 'music',
      component: music
    },
    {
      path: '/nature',
      name: 'nature',
      component: nature
    },
    {
      path: '/politics',
      name: 'politics',
      component: politics
    },
    {
      path: '/sports',
      name: 'sports',
      component: sports
    },
    {
      path: '/vehiles',
      name: 'vehiles',
      component: vehiles
    },
    {
      path: '/videoG',
      name: 'videoG',
      component: videoG
    }

  ]
})
